import { Paragraph, SectionHeader } from '@swordhealth/ui-corporate';
import styled from 'styled-components';

export const StyledSectionHeader = styled(SectionHeader)`
  row-gap: 16px;

  h2 {
    margin: 0;
  }
`;

export const StyledParagraph = styled(Paragraph)`
  text-align: center;
  margin: 32px 0 8px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    margin: 24px 0 8px 0;
  }
`;
export const CardFooter = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.grey.light};
  display: flex;
  flex-direction: column;
  margin-top: auto;
`;

export const LinksWrapper = styled.div`
  align-items: center;
  display: flex;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const CustomCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  height: fit-content;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    gap: 24px;

    svg {
      width: 140px;
      height: 140px;
    }
  }
`;

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;
